import React from 'react';
import { graphql } from 'gatsby';
import { withPreview } from '../utils/withPreview';
import PageWrapper from '../components/PageWrapper/PageWrapper';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import SectionSlots from '../slots/SectionSlots/SectionSlots';
import { PAGE_QUERY } from './__generated__/PAGE_QUERY';
import Box from '../components/Box/Box';

const Page = ({
    data: { page },
    location,
}: {
    data: PAGE_QUERY;
    location: any;
}) => {
    const { body } = page.data;
    const { primary: { hide_header, hide_footer } = {} } = body[0] || {};
    const sections = body[0].items.filter(
        ({ section }) => section?.document?.data
    );
    return (
        <PageWrapper page={page}>
            {hide_header ? null : <Header />}
            <Box as="main" flexGrow={1}>
                <SectionSlots sections={sections} location={location} />
            </Box>
            {hide_footer ? null : <Footer />}
        </PageWrapper>
    );
};

export const PAGE_META_FRAGMENT = graphql`
    fragment PAGE_META_FRAGMENT on PrismicPageDataType {
        slug
        page_title
        description
        meta_image {
            alt
            url
        }
        canonical_url
    }
`;

export const query = graphql`
    query PAGE_QUERY($uid: String!, $lang: String!) {
        page: prismicPage(uid: { eq: $uid }, lang: { eq: $lang }) {
            _previewable
            lang
            data {
                ...PAGE_META_FRAGMENT
                body {
                    ... on PrismicPageDataBodyStandardPage {
                        primary {
                            hide_header
                            hide_footer
                        }
                        items {
                            section {
                                document {
                                    ...SECTIONS_FRAGMENT
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

export default withPreview(Page);
